<template>
  <p class="search-stats-text">
    {{ numberOfHits }} / {{ resolvedTotalCount }} {{ statsText }}
  </p>
</template>

<script>
export default {
  name: "SearchStats",
  inject: {
    initialHits: {
      default: 42,
    },
  },
  props: {
    numberOfHits: {
      type: Number,
      required: true,
      default: 0,
    },
    statsText: {
      type: String,
      required: true,
      default: "job(s)",
    },
    totalCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    resolvedTotalCount() {
      // If totalCount is provided via prop, like in the CF, return it directly
      if (this.totalCount) return this.totalCount;

      // Only if totalCount is not provided, like it will be the case in the RH
      // If initialHits is smaller than the actual number of hits, make them the same to prevent e.g. "76/15 offers"
      if (this.initialHits < this.numberOfHits) {
        return this.numberOfHits;
      } else {
        return this.initialHits;
      }
    },
  },
};
</script>
